import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { createActor } from 'xstate';
import { editorPluginAIMachine } from './editor-plugin-ai-machine';

/**
 * Weakmap cache for caching an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
 * per EditorView.
 *
 * It contains a convenience function for returning an actor if it exists in the cache (`getActor`)
 */
var AIActorCache = /*#__PURE__*/function (_WeakMap) {
  function AIActorCache() {
    _classCallCheck(this, AIActorCache);
    return _callSuper(this, AIActorCache, arguments);
  }
  _inherits(AIActorCache, _WeakMap);
  return _createClass(AIActorCache, [{
    key: "getActor",
    value:
    /**
     * Returns an actor if it exists in the cache or creates and starts a new one.
     *
     * @param editorView
     * @returns [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
     */
    function getActor(editorView) {
      if (this.has(editorView)) {
        return this.get(editorView);
      }
      var editorPluginAIActor = createActor(editorPluginAIMachine);
      editorPluginAIActor.start();
      aiActorCache.set(editorView, editorPluginAIActor);
      return editorPluginAIActor;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(WeakMap));
/**
 * Global cache used to manage an an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api) per
 * EditorView for the AI Editor Plugin.
 */
export var aiActorCache = new AIActorCache();